import { render } from "./onlineInfo.vue?vue&type=template&id=19008a1a&scoped=true"
import script from "./onlineInfo.vue?vue&type=script&lang=js"
export * from "./onlineInfo.vue?vue&type=script&lang=js"

import "./onlineInfo.vue?vue&type=style&index=0&id=19008a1a&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19008a1a"]])

export default __exports__